<template>
  <div class="overflow-auto">
    <b-container fluid>
      <b-button v-if="this.user.name == 'Rick'">Test function</b-button>
      <h1>Events</h1>

      <b-form-checkbox
        :disabled="isSearching || showAcceptedEvents == 'yes' || showWaitingEvents == 'yes'"
        v-model="showOlderEvents"
        value="yes"
        unchecked-value="no"
        >Show older events</b-form-checkbox
      >
      <b-form-checkbox
        :disabled="isSearching || showWaitingEvents == 'yes'"
        v-model="showAcceptedEvents"
        value="yes"
        unchecked-value="no"
        >Show accepted events</b-form-checkbox
      >
      <b-form-checkbox
        :disabled="isSearching || showAcceptedEvents == 'yes'"
        v-model="showWaitingEvents"
        value="yes"
        unchecked-value="no"
        >Show waiting events</b-form-checkbox
      >
      <b-form-checkbox
        class="mb-3"
        :disabled="isSearching || showAcceptedEvents == 'yes' || showWaitingEvents == 'yes'"
        v-model="showAllEvents"
        value="yes"
        unchecked-value="no"
        >Show completed events</b-form-checkbox
      >
      <!-- <b-form-checkbox :disabled="isSearching" v-model="showComplaintEvents" value="yes" unchecked-value="no">Show events including complaints</b-form-checkbox> -->

      <b-dropdown
        v-if="this.user.role == 'sales' || this.user.role == 'admin'"
        variant="primary"
        text="Add a new row"
      >
        <b-dropdown-item @click="addSmallTask()"
          >Small Task <b-icon icon="plus" scale="1.5" variant="primary"></b-icon
        ></b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="addInstallation()"
          >Installation
          <b-icon icon="plus" scale="1.5" variant="primary"></b-icon
        ></b-dropdown-item>
        <!-- <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="addInscription()">Inscription <b-icon icon="plus" scale="1.5" variant="primary"></b-icon></b-dropdown-item> -->
      </b-dropdown>

      <div>
        <b-row>
          <b-col cols="10">
            <b-form-group label="Filter:" label-for="customFilterCriteria">
              <b-input-group>
                <b-form-input
                  type="text"
                  id="customFilterCriteria"
                  v-model="filterForm_filterKeyword"
                  class="form-control"
                  placeholder="Type to search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="cleanFilterInfo"
                    ><b-icon icon="x-circle" variant="white"></b-icon
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group label="On:" label-for="customFilterOn">
              <b-form-select
                id="customFilterOn"
                style="display: inline;"
                v-model="filterForm_filterOn"
                :options="filterForm_filterCriterias"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <b-pagination
        v-model="currentPage"
        :page="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>

      <!-- <p class="mt-3">Current Page: {{ currentPage }}</p> -->

      <b-table
        class="pointer"
        id="my-table"
        responsive
        striped
        hover
        @row-clicked="myRowClickHandler"
        :fields="event_fields"
        :filter="filterCriteria"
        :filter-included-fields="filterOn"
        :items="displayed_events"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :busy="tableIsBusy"
        small
      >
        <template #cell(invoice_number)="row">
          <div class="d-inline-block text-truncate" style="min-width: 90px; max-width: 140px">
            {{ row.item.invoice_number }}
          </div>
        </template>

        <template #cell(job_style)="row">
          <div class="text-wrap text-truncate mb-0" style="max-width: 100px;">
            <p class="m-0">
              {{ row.item.job_style }}
              <span v-if="row.item.job_style == null || row.item.job_style.length == 0">
                N/A
              </span>
            </p>
          </div>
        </template>

        <template #cell(start_date)="row">
          <div style="max-width: 180px">
            <p
              class="mb-0"
              v-if="
                row.item.type != 'installation' && row.item.start_date != null && row.item.start_date.length > 0
              "
            >
              {{ row.item.start_date }}
            </p>
            <p
              class="mb-0"
              v-if="
                row.item.type == 'installation' && row.item.start_date != null && row.item.start_date.length > 0
              "
            >
              Ashlar: {{ row.item.start_date }}
            </p>
            <p
              class="mb-0"
              v-if="
                row.item.headstone_start_date != null &&
                  row.item.headstone_start_date.length > 0
              "
            >
              Headstone: {{ row.item.headstone_start_date }}
            </p>
            <p
              class="mb-0"
              v-if="
                (row.item.start_date == null || row.item.start_date.length == 0) &&
                  (row.item.headstone_start_date == null ||
                    row.item.headstone_start_date.length == 0)
              "
            >
              Not accepted
            </p>
          </div>
        </template>

        <template #cell(due_date)="row">
          <div class="text-wrap text-truncate" style="max-width: 90px">
            {{ row.item.due_date }}
          </div>
        </template>

        <template #cell(cemetery)="row">
          <p style="max-width: 200px">
            {{ row.item.cemetery }}
            <span v-if="row.item.cemetery == null || row.item.cemetery.length == 0">
              N/A
            </span>  
          </p>
        </template>

        <template #cell(status)="row">
          <div style="max-width: 140px">
            <b-badge class="mx-1" variant="warning" v-if="row.item.is_suspended"
              v-b-tooltip.hover :title="row.item.suspend_reason">
              Suspended
            </b-badge>
            <span v-if="!row.item.is_suspended">
              <b-badge class="mx-1" variant="danger" v-if="row.item.isPending">
                pending
              </b-badge>
              <b-badge class="mx-1" variant="danger" v-if="row.item.isOverdue">
                overdue
              </b-badge>
              <b-badge
                class="mx-1"
                variant="warning"
                v-if="row.item.isRequestingForCompletion"
              >
                waiting
              </b-badge>
              <b-badge
                class="mx-1"
                v-if="row.item.isAccepted && !row.item.isRequestingForCompletion"
                :class="{
                  'bg-success': row.item.status == 'active',
                  'bg-danger': row.item.status == 'overdue',
                }"
              >
                {{ row.item.status }}
              </b-badge>
              <b-badge class="mx-1" v-if="!row.item.isAccepted && !row.item.isDraft"> ready </b-badge>
              <b-badge class="mx-1" v-if="row.item.isDraft"> draft </b-badge>
            </span>
          </div>
        </template>

        <template #cell(tagStrings)=""> </template>

        <template #cell(actions)="row">
          <b-button size="sm" @click="showDetails(row.item)">
            Details
          </b-button>
          <b-button
            class="ml-1"
            size="sm"
            @click="deleteEvent(row.item)"
            variant="danger"
          >
            Delete
          </b-button>
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
    </b-container>

    <b-modal id="create-inscription" hide-footer title="Create an inscription">
      <b-container>
        <b-row>
          <b-col cols="6">
            <label for="new_order_number">Order number:</label>
            <input
              type="text"
              id="new_order_number"
              v-model="newInscription.order_number"
              class="form-control"
            />
          </b-col>
          <b-col cols="6">
            <label for="order_date">Order date:</label>
            <p id="order_date" class="form-control">{{ today }}</p>
          </b-col>
        </b-row>
      </b-container>
      <div class="modal-footer">
        <b-button @click="hideModal('create-inscription')"> Cancel </b-button>
        <b-button class="ml-1" variant="primary" @click="createInscription()">
          Create
        </b-button>
      </div>
    </b-modal>

    <b-modal
      id="modal-delete-confirmation"
      hide-footer
      title="Delete Comfirmation"
    >
      <p>
        Are you sure you want to delete {{ this.deletedEvent.invoice_number }}?
        The event will be permanently deleted.
      </p>
      <div class="modal-footer">
        <b-button
          variant="primary"
          @click="hideModal('modal-delete-confirmation')"
        >
          Cancel
        </b-button>
        <b-button variant="danger" @click="deleteTask()"> Delete </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  data() {
    return {
      showWaitingEvents: false,
      showAcceptedEvents: false,
      waitingEvents: [],
      acceptedEvents: [],
      tableIsBusy: true,
      currentPage: 1,
      activeEvents: [],
      completedEvents: [],
      deletedEvent: {},
      isSearching: false,
      oldFilterCriteria: "",
      customFilterCriteria: "",
      showAllEvents: "",
      showOlderEvents: "yes",
      showComplaintEvents: "no",
      sortBy: "due_date",
      sortDesc: false,
      show: false,
      perPage: 20,
      displayed_events: [],
      running_events: [],
      all_events: [],
      filterCriteria: "",
      filterOn: [
        "order_date",
        "invoice_number",
        "job_style",
        "status",
        "due_date",
        "cemetery",
        "installation_staff_name",
        "sales_name",
        "type",
        "start_date",
        "tagStrings",
      ],
      oldFilterOn: ["status"],
      customFilterOn: [
        "invoice_number",
        "status",
        "due_date",
        "cemetery",
        "installation_staff_name",
        "sales_name",
        "type",
        "start_date",
      ],
      event_fields: [
        { key: "start_date", label: "Start Date" },
        { key: "due_date", label: "Due Date" },
        { key: "invoice_number", label: "Invoice #" },
        { key: "job_style", label: "Style" },
        { key: "installation_staff_name", label: "Installation" },
        { key: "sales_name", label: "Sales" },
        { key: "type", label: "Type" },
        { key: "cemetery", label: "Cemetery" },
        { key: "status", label: "Status" },
        { key: "actions", label: "Actions" },
        { key: "tagStrings", label: "" },
      ],
      newInscription: {
        order_number: "",
        order_date: "",
      },
      filterForm_filterKeyword: "",
      filterForm_filterOn: "all",
      filterForm_filterCriterias: [
        "all",
        "cemetery",
        "job_style",
        "due_date",
        "installation_staff",
        "invoice_number",
        "sales",
        "start_date",
        "type",
      ],
    };
  },
  props: {
    user: Object,
    filterInfo: {
      filterForm_filterKeyword: "",
      filterForm_filterOn: "",
    },
    globalCurrentPage: Number,
  },
  computed: {
    rows: function() {
      if (this.displayed_events.length == 0) {
        return 100;
      } else {
        return this.displayed_events.length;
      }
    },
    today: function() {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yyyy = now.getFullYear();
      return yyyy + "-" + mm + "-" + dd;
    },
  },
  created() {
    this.$emit('ResetCRMOrder');
    const db = firebase.firestore();

    if (this.user.role == "admin" || this.user.name == "Christine" || this.user.name == "Peter" || this.user.name == "Paul") {
      db.collection("activeEvents").onSnapshot((collection) => {
        this.activeEvents = [];
        this.waitingEvents = [];
        this.acceptedEvents = [];
        collection.docs.forEach((doc) => {
          if (doc.data().id == null) {
            // console.log(doc);
            // console.log(doc.data());
          }
        });
        this.activeEvents = collection.docs.map((doc) => doc.data());
        this.activeEvents.forEach((row) => {
          if (row.isRequestingForCompletion && !row.is_suspended) this.waitingEvents.push(row);
          if (!row.isRequestingForCompletion && row.isAccepted && !row.is_suspended) this.acceptedEvents.push(row);
        });
        // console.log(this.activeEvents);
        this.displayed_events = this.activeEvents;
        this.setTableParameters();
        this.tableIsBusy = false;
        if (this.showAllEvents == "no") {
          this.displayed_events = this.all_events;
        }
      });
    } else if (this.user.role == "sales") {
      db.collection("activeEvents")
        .where("sales.id", "==", this.user.id)
        .where("isPending", "==", false)
        .onSnapshot((collection) => {
          this.activeEvents = [];
          this.waitingEvents = [];
          this.acceptedEvents = [];
          this.activeEvents = collection.docs.map((doc) => doc.data());
          this.activeEvents.forEach((row) => {
            if (row.isRequestingForCompletion && !row.is_suspended) this.waitingEvents.push(row);
            if (!row.isRequestingForCompletion && row.isAccepted && !row.is_suspended) this.acceptedEvents.push(row);
          });
          this.displayed_events = this.activeEvents;
          this.setTableParameters();
          this.tableIsBusy = false;
          if (this.showAllEvents == "no") {
            this.displayed_events = this.all_events;
          }
        });
    } else if (this.user.role == "worker") {
      db.collection("activeEvents")
        .where("installation_staff.id", "==", this.user.id)
        .where("isPending", "==", false)
        .where("isDraft", "==", false)
        .onSnapshot((collection) => {
          this.activeEvents = [];
          this.waitingEvents = [];
          this.acceptedEvents = [];
          this.activeEvents = collection.docs.map((doc) => doc.data());
          this.activeEvents.forEach((row) => {
            if (row.isRequestingForCompletion && !row.is_suspended) this.waitingEvents.push(row);
            if (!row.isRequestingForCompletion && row.isAccepted && !row.is_suspended) this.acceptedEvents.push(row);
          });
          this.displayed_events = this.activeEvents;
          this.setTableParameters();
          this.tableIsBusy = false;
          if (this.showAllEvents == "no") {
            this.displayed_events = this.all_events;
          }
        });
    }
  },
  watch: {
    currentPage(newCurrentPage) {
      this.$emit("changeGlobalPage", newCurrentPage);
    },
    filterForm_filterKeyword(newFilterForm_filterKeyword) {
      this.filterCriteria = newFilterForm_filterKeyword;
      const filterInfo = {
        filterForm_filterKeyword: newFilterForm_filterKeyword,
        filterForm_filterOn: this.filterForm_filterOn,
      };
      this.currentPage = 1;
      this.$emit("changeFilterInfo", filterInfo);
    },
    filterForm_filterOn(newFilterForm_filterOn) {
      if (newFilterForm_filterOn == "all") {
        this.filterOn = [
          "invoice_number",
          "job_style",
          "status",
          "due_date",
          "cemetery",
          "installation_staff_name",
          "sales_name",
          "type",
          "start_date",
        ];
        console.log("criteria set to all");
      } else {
        this.filterOn = [newFilterForm_filterOn];
      }

      if (this.filterCriteria.length > 0) this.currentPage = 1;

      const filterInfo = {
        filterForm_filterKeyword: this.filterForm_filterKeyword,
        filterForm_filterOn: newFilterForm_filterOn,
      };
      this.$emit("changeFilterInfo", filterInfo);
    },
    showAllEvents(newShowAllEvents) {
      if (newShowAllEvents == "yes") {
        if (this.all_events.length == 0) {
          this.setAllEventsSnapshot();
        } else {
          this.displayed_events = this.all_events;
        }
      } else {
        this.displayed_events = this.activeEvents;
      }
    },
    showOlderEvents(newShowOlderEvents) {
      if (newShowOlderEvents == "yes") {
        if (this.showAllEvents == "yes") {
          if (this.all_events.length == 0) {
            this.setAllEventsSnapshot();
          } else {
            this.displayed_events = this.all_events;
          }
        } else {
          this.displayed_events = this.activeEvents;
        }
      } else {
        if (this.running_events.length == 0) {
          this.setRunningEventsSnapshot();
        } else {
          this.displayed_events = this.running_events;
        }
      }
    },
    showWaitingEvents(data) {
      if(data == "yes") {
        this.displayed_events = this.waitingEvents;
      } else {
        this.displayed_events = this.activeEvents;
      }
    },
    showAcceptedEvents(data) {
      if(data == "yes") {
        this.displayed_events = this.acceptedEvents;
      } else {
        this.displayed_events = this.activeEvents;
      }
    },
    customFilterCriteria(newCustomFilterCriteria, oldCustomFilterCriteria) {
      if (
        newCustomFilterCriteria.length > 0 &&
        oldCustomFilterCriteria.length == 0
      ) {
        this.oldFilterCriteria = this.filterCriteria;
        this.filterCriteria = this.customFilterCriteria;

        this.oldFilterOn = this.filterOn;
        this.filterOn = this.customFilterOn;

        this.isSearching = true;
      } else if (
        newCustomFilterCriteria.length > 0 &&
        oldCustomFilterCriteria.length > 0
      ) {
        this.filterCriteria = this.customFilterCriteria;

        this.filterOn = this.customFilterOn;
        this.isSearching = true;
      } else if (newCustomFilterCriteria.length == 0) {
        this.filterCriteria = this.oldFilterCriteria;

        this.filterOn = this.oldFilterOn;
        this.isSearching = false;
      }
    },
  },
  methods: {
    // moveCompleteEvents() {
    //   const db = firebase.firestore();

    //   db.collection("events").get()
    //     .then((snapshot) => {
    //       snapshot.forEach((doc) => {
    //         const data = doc.data();
    //         if (data.status == 'completed') {
    //           db.collection("completeEvents").doc(data.id).set(data);
    //         } else {
    //           db.collection("activeEvents").doc(data.id).set(data);
    //         }
    //       });
    //     });
    // },
    setAllEventsSnapshot() {
      const db = firebase.firestore();
      this.tableIsBusy = true;
      if (this.user.role == "admin" || this.user.name == "Christine" || this.user.name == "Peter" || this.user.name == "Paul") {
        db.collection("events").onSnapshot((collection) => {
          this.all_events = [];
          this.all_events = collection.docs.map((doc) => doc.data());
          this.displayed_events = this.all_events;
          this.tableIsBusy = false;
        });
      } else if (this.user.role == "sales") {
        db.collection("events")
          .where("sales.id", "==", this.user.id)
          .where("isPending", "==", false)
          .onSnapshot((collection) => {
            this.all_events = [];
            this.all_events = collection.docs.map((doc) => doc.data());
            this.displayed_events = this.all_events;
            this.tableIsBusy = false;
          });
      } else if (this.user.role == "worker") {
        db.collection("events")
          .where("installation_staff.id", "==", this.user.id)
          .where("isPending", "==", false)
          .onSnapshot((collection) => {
            this.all_events = [];
            this.all_events = collection.docs.map((doc) => doc.data());
            this.displayed_events = this.all_events;
            this.tableIsBusy = false;
          });
      }
    },
    setRunningEventsSnapshot() {
      const db = firebase.firestore();
      this.tableIsBusy = true;
      if (this.user.role == "admin" || this.user.name == "Christine" || this.user.name == "Peter" || this.user.name == "Paul") {
        db.collection("activeEvents")
          .where("due_date", ">=", this.today)
          .onSnapshot((collection) => {
            this.running_events = [];
            this.running_events = collection.docs.map((doc) => doc.data());
            this.displayed_events = this.running_events;
            this.tableIsBusy = false;
          });
      } else if (this.user.role == "sales") {
        db.collection("activeEvents")
          .where("sales.id", "==", this.user.id)
          .where("isPending", "==", false)
          .where("due_date", ">=", this.today)
          .onSnapshot((collection) => {
            this.running_events = [];
            this.running_events = collection.docs.map((doc) => doc.data());
            this.displayed_events = this.running_events;
            this.tableIsBusy = false;
          });
      } else if (this.user.role == "worker") {
        db.collection("activeEvents")
          .where("installation_staff.id", "==", this.user.id)
          .where("isPending", "==", false)
          .where("due_date", ">=", this.today)
          .onSnapshot((collection) => {
            this.running_events = [];
            this.running_events = collection.docs.map((doc) => doc.data());
            this.displayed_events = this.running_events;
            this.tableIsBusy = false;
          });
      }
    },
    cleanFilterInfo() {
      this.filterForm_filterKeyword = "";
    },
    setTableParameters() {
      this.currentPage = this.globalCurrentPage;
      if (this.filterInfo != null) {
        this.filterForm_filterKeyword = this.filterInfo.filterForm_filterKeyword;
        this.filterForm_filterOn = this.filterInfo.filterForm_filterOn;
      }
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    showAddPage() {
      this.$emit("addEvent", true);
    },
    myRowClickHandler(item) {
      console.log(item);
    },
    showDetails(item) {
      this.$emit("showEventDetails", {
        event: item,
        from: "Events",
        currentPage: this.currentPage,
        filterInfo: {
          filterForm_filterKeyword: this.filterForm_filterKeyword,
          filterForm_filterOn: this.filterForm_filterOn,
        },
      });
    },
    deleteEvent(item) {
      if (this.user.role == "admin") {
        this.deletedEvent = item;
        this.showModal("modal-delete-confirmation");
      } else {
        alert("You have no authority to delete this event.");
      }
    },
    deleteTask() {
      const admin = firebase.firestore();
      this.deletedEvent.deletedDate = this.today;
      this.deletedEvent.deletedBy = this.user;

      admin
        .collection("deletedEvents")
        .doc(this.deletedEvent.id)
        .set(this.deletedEvent)
        .then(() => {
          console.log("deletedEvents added");
        });

      admin
        .collection("activeEvents")
        .doc(this.deletedEvent.id)
        .delete();

      admin
        .collection("events")
        .doc(this.deletedEvent.id)
        .delete()
        .then(() => {
          // Successfully deleted the event
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });

      this.hideModal("modal-delete-confirmation");
    },
    addSmallTask() {
      this.$emit("addSmallTask");
    },
    addInstallation() {
      this.$emit("addInstallation");
    },
    addInscription() {
      this.$emit("addInscription");
    },
    createInscription() {
      console.log("createInscription");
    },
    setTest() {
      var database = firebase.firestore();
      database
        .collection("activeEvents")
        .doc("M6bnw3AniKQxSVXd6L8d")
        .set({ new: "new" }, { merge: true });
    },
    testFunction() {
      var database = firebase.firestore();
      this.all_events.forEach((element) => {
        const eventRef = database.collection("events").doc(element.id);

        eventRef.update({
          sales_name: element.sales.name,
          installation_staff_name: element.installation_staff.name,
        });
      });

      this.activeEvents.forEach((element) => {
        const eventRef = database.collection("activeEvents").doc(element.id);

        eventRef.update({
          sales_name: element.sales.name,
          installation_staff_name: element.installation_staff.name,
        });
      });
    },
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}

p {
  margin: 0 !important;
}
</style>
